<div *ngIf="!downloadItems">

  <!--Loading Image-->
  <div aria-hidden="true" class="download-item-spinner m-3">
    <div class="row download-item py-3">
      <div class="col-12 col-xl-6">
        <div class="d-flex">
          <div class="flex-shrink-0 border bg-white me-3 product-download-image justify-content-center align-items-center d-flex">
           <app-spinner [size]="2" class="d-block text-black-50 text-center"></app-spinner>
          </div>
          <div class="flex-grow-1">
            <p class="mb-1 mock-text">
              Vendor
            </p>
            <p class="mock-text">
              Product
            </p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 mt-3 align-self-center">
        <div class="row">
          <div class="col">
            <div class="mock-text-header">&nbsp;</div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="mt-3 mock-text-long">&nbsp;</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="items-list" *ngIf="itemsAvailable else emptyMessage">
  <div class="m-3" *ngFor="let downloadItem of downloadItems">
    <app-download-item [downloadInfo]="downloadItem"></app-download-item>
  </div>
</div>
<ng-template #emptyMessage>
  <div id="emptyMessageDiv" *ngIf="downloadItems">
    <span class="mt-4">You have no available downloads.</span>
  </div>
</ng-template>
